import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { ThemeService } from '@aurrica-web/core-data';
import { ThemeButton } from '@aurrica-web/ui';

/**
 * Full-page wrapper for unauthenticated routes: theme-aware background,
 * centered content projection, and theme toggle.
 */
@Component({
  selector: 'lib-auth-page-shell',
  imports: [CommonModule, ThemeButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="relative flex min-h-screen items-center justify-center p-4 bg-cover bg-center bg-no-repeat bg-background-light dark:bg-background-dark transition-colors duration-300"
      [style.background-image]="backgroundImage()"
    >
      <div
        class="pointer-events-none absolute inset-0 bg-white/40 dark:bg-[#020817]/55"
        aria-hidden="true"
      ></div>

      <div class="absolute top-4 right-4 z-20" aria-label="Theme">
        <lib-ui-theme-button />
      </div>

      <div class="relative z-10 w-full max-w-md mx-auto">
        <ng-content />
      </div>
    </div>
  `,
})
export class AuthPageShell {
  private readonly themeService = inject(ThemeService);

  constructor() {
    // Ensure ThemeService effect runs on auth routes (sync with localStorage).
    this.themeService.isDarkMode();
  }

  protected readonly backgroundImage = computed(() => {
    const file = this.themeService.isDarkMode()
      ? 'auth-bg-dark.png'
      : 'auth-bg-light.png';
    return `url('./assets/auth/${file}')`;
  });
}
